import '@/styles/main.scss'

import { createApp } from 'vue'
import App from '@/app.vue'
import i18n from '@/locales'
import { toastPlugin } from '@/plugins/toast-pop'
import {
  useDynamicLayout,
  type UseDynamicLayoutPluginOption
} from '@/plugins/use-dynamic-layout'
import router from '@/router'
import { piniaInstance } from '@/stores/pinia-instance'

const app = createApp(App)
const globals = app.config.globalProperties

app.config.globalProperties.$toast = toastPlugin

app
  .use(i18n)
  .use(piniaInstance)
  .use(router)
  .use<UseDynamicLayoutPluginOption>(useDynamicLayout, {
    router,
    layoutInFolder: true
  })
  .provide('$toast', toastPlugin)
  .mount('#app')

// 監聽 vite preloadError 並重新整理網站
window.addEventListener('vite:preloadError', () => {
  location.reload()
})

export { globals }
